import type { SendWhatsAppDTO } from '../types';
import { buildBasePayload, WhatsAppPayload } from './basePayload';
import { API_TWILIO } from 'src/constants/conversations';

/**
 * Builds the request payload for Twilio provider.
 */
export function buildTwilioPayload(dto: SendWhatsAppDTO): WhatsAppPayload {
    const base = buildBasePayload(dto);
    const payload: WhatsAppPayload = {
        to: dto.to,
        from: dto.from,
        ...base,
        api: API_TWILIO,
    };
    return payload;
}
